import "@/styles/globals.css";
import { TranslationProvider } from "@/contexts/TranslationContext";
import ThemeRouter from "@/contexts/ThemeRouter";
import { CurrencyProvider } from "@/contexts/CurrencyContext";
import CookieConsent from "@/components/consent/CookieConsent";
import CookieSettingsButton from "@/components/consent/CookieSettingsButton";

export default function App({ Component, pageProps }) {
  return (
    <TranslationProvider
      initialLocale={pageProps.initialLocale || "hu"}
      initialTranslations={pageProps.initialTranslations || {}}
    >
      <CurrencyProvider>
        <ThemeRouter
          products={pageProps.products}
          layoutProps={{
            hideHeader: Component.hideHeader,
            hideFooter: Component.hideFooter,
            enableMoreProducts: Component.enableMoreProducts,
          }}
        >

          <Component {...pageProps} />
          <CookieConsent />
          <CookieSettingsButton />

        </ThemeRouter>
      </CurrencyProvider>
    </TranslationProvider>
  );
}